import React from 'react';
import { NavBar } from '../../../components/essentials/navbar/navbar.component';
import { Footer } from '../../../components/essentials/footer/footer.component';
import {Getstarted} from '../../../components/essentials/get-started/getstarted.component';
import { OverlapBoxTechno } from '../techno.component';
import phoneImg from '../../../assest/phoneImg/Liveness Detection.png';
import './live-detect.styles.scss';

export const LiveDetect = () => (
  <div className='blogs-main'>
    <NavBar />
    <HeaderHalf title='Liveness Detection' uris='Liveness Detection' />
    <OverlapBoxTechno
      img={phoneImg}
      title='Put An End To Face Biometric Spoofing With Liveness Detection Feature.'
    >
      <p>
        With increasing online fraud and identity theft, identity authentication service providers
        like EarthId need to ensure that there is no scope left for a security gap in the prevalent
        biometric systems. Even a minor security gap can lead to fraudsters successfully spoofing a
        facial recognition system.
      </p>
      <p>
        Owing to the criticality of the security gaps of current biometric systems, EarthId’s
        Liveness Detection technology protects users from spoofing attempts in unsupervised
        situations. Our anti-spoofing biometric algorithms are so powerful that our system cannot be
        easily fooled by spoofing techniques. Facial Liveness detection aims to analyze facial
        reactions to ensure the captured biometric information is from a living/moving subject.
      </p>
      <p>
        EarthId’s Liveness Detection Authentication offers reliable anti-spoofing against biometric
        frauds. To experience frictionless authentication with EarthId, contact our experts and get
        to know more about our robust system.
      </p>
    </OverlapBoxTechno>
    <Getstarted/>
    <Footer />
  </div>
);

const HeaderHalf = ({ title, uris }) => {
  return (
    <div className='headerHalf-main-live'>
      <div className='headerHalf-content'>
        <p className='headerHalf-title'>{title}</p>
        <p className='headerHalf-uris'>
        Platform / <span className='uris-class'>{uris}</span>
        </p>
      </div>
    </div>
  );
};
